import {inject, injectable} from 'inversify';

import type {CleanedCategory} from '../../../../api/category';
import type {IApiDataMapper} from '../../../ports/types';

import {CategoryFactory} from '../Category.factory';
import {CategoryModel} from '../Category.model';
import {CategoryExpandJrpc} from './Category.expand.jrpc';

@injectable()
export class CategoryMapperJrpc
  implements
    IApiDataMapper<
      CategoryMapperJrpc.ApiData,
      CategoryModel.Props,
      CategoryModel
    >
{
  constructor(
    @inject(CategoryFactory)
    private readonly factory: CategoryFactory,
    @inject(CategoryExpandJrpc)
    public readonly expand: CategoryExpandJrpc,
  ) {}

  mapDataToModel(apiData: CategoryMapperJrpc.ApiData): CategoryModel {
    return this.factory.create(this.mapDataToProps(apiData));
  }

  mapDataToProps(apiData: CategoryMapperJrpc.ApiData): CategoryModel.Props {
    return {
      apiData,
      icon: apiData.icon,
      id: apiData._id,
      level: apiData.level,
      parentIds: apiData.parent_ids,
      slug: apiData.slug,
      title: apiData.title,
      type: this.type(apiData),
      weight: apiData.weight,
    };
  }

  private type(apiData: CategoryMapperJrpc.ApiData): CategoryModel.Type {
    switch (apiData.type) {
      case 'article':
        return CategoryModel.Type.ARTICLE;
      case 'population':
        return CategoryModel.Type.POPULATION;
      case 'program':
        return CategoryModel.Type.PROGRAM;
      default:
        return CategoryModel.Type.PROGRAM;
    }
  }
}

export namespace CategoryMapperJrpc {
  export type ApiData = CleanedCategory;

  export type ExpandedApiData = ApiData & CategoryExpandJrpc.ExpandedFields;
}
